import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JobOverlayDisplayService {

  constructor() {

  }

  private jobOverlaySubject = new BehaviorSubject<number>(1);

  public jobOverlayWatch(): Observable<number> {
    return this.jobOverlaySubject.asObservable();
  }

  public closeOverlay(): void {
    this.jobOverlaySubject.next(this.jobOverlaySubject.value + 1);
  }

  public isOpen(): boolean {
    return this.jobOverlaySubject.observed;
  }
}
